// Whatsapp.jsx
import React, { Component } from "react";
import WhatsappChatList from "./WhatsappChatList";
import WhatsappChatStarted from "./WhatsappChatStarted";
import WhatsAppNewChat from "./WhatsAppNewChat";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import { connect } from "react-redux";
import ChatAssistant from "../ChatAssistant";

class Whatsapp extends Component {
  state = {
    isChatAssistantVisible: false,
    // 1) We'll store the timestamps in parent state
    seekRange: null,
  };

  // Show chat assistant
  showChatAssistant = () => {
    this.setState({ isChatAssistantVisible: true });
  };

  // Close chat assistant
  closeChatAssistant = () => {
    this.setState({ isChatAssistantVisible: false });
  };

  // 2) This is the callback we pass to ChatAssistant
  // It receives the start/end timestamps and saves them in local state
  seekChatRange = (start, end) => {
    this.setState({ seekRange: { start, end } });
  };

  // A small helper to conditionally render the main chat area
  isChatStarted = () => {
    const { showChatAssistant, state } = this;

    // Checking if the URL ends with /whatsapp/<some-id> means a chat started
    if (
      this.props.location.pathname.includes(
        "/dashboard/message-overview/whatsapp/"
      )
    ) {
      return (
        <WhatsappChatStarted
          showChatAssistant={showChatAssistant}
          isChatAssistantVisible={state.isChatAssistantVisible}
          // 3) Pass the timestamps down to WhatsappChatStarted
          seekRange={this.state.seekRange}
        />
      );
    } else if (
      this.props.location.pathname.includes(
        "/dashboard/message-overview/whatsapp"
      )
    ) {
      // If no session, show new chat
      return <WhatsAppNewChat />;
    }
  };

  render() {
    const { isChatAssistantVisible } = this.state;

    return (
      <div
        className="w-full h-full p-4 flex gap-4 overflow-hidden"
        style={{
          background:
            "radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 50%), radial-gradient(ellipse at bottom center, #eff6ff 0%, transparent 60%), #f8faff",
        }}
      >
        <WhatsappChatList />
        <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
          {this.isChatStarted()}
        </div>

        {isChatAssistantVisible && (
          <ChatAssistant
            closeChatAssistant={this.closeChatAssistant}
            seekChatRange={this.seekChatRange}
          />
        )}
      </div>
    );
  }
}

export default withRouterHooks(Whatsapp);
